// TODO: Move this JS file to Webpack folder since it is now only consumed by
// Webpacker-compiled applications
import 'angular';

angular.module('directives.visualizations.chartLegend', [])
  .directive('chartLegend', [
    function() {
      return {
        restrict: 'E',
        template:
          '<div class="chart-legend">' +
            '<div ' +
              'class="item" ' +
              'ng-repeat="item in data" ' +
              'data-id="{{ item.key }}" ' +
              'ng-mouseover="mouseover(item.key)" ' +
              'ng-mouseout="mouseout(item.key)" ' +
              'ng-click="click(item.key, \'legend\')" ' +
              'title="{{ item.key }}">' +
              '<div ' +
                'class="color-box" ' +
                'style="background-color: {{ color(item.value) }}">' +
              '</div>' +
              '<div class="text">' +
                '{{ item.key }}' +
              '</div>' +
            '</div>' +
          '</div>',
        scope: {
          mouseover: '=',
          mouseout: '=',
          click: '=',
          data: '=',
          color: '='
        }
      };
    }
  ]);
